import type { FC } from "react";

export interface MetaProps {
  title?: string;
  pageType?: string;
  description?: string;
  keywords?: string;
}

export const Meta: FC<MetaProps> = ({
  title = "Partner",
  description = "Partner",
  // TODO: сделать автоматическим определение pageType в зависимости от роута, когда будет актуально
  pageType = "Admin",
  keywords,
}) => {
  const fullTitle = `${title} [${pageType}]`;

  return (
    <>
      {/* React 19 автоматически поднимет эти теги в <head> */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}

      {/* Open Graph (для соцсетей) */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
    </>
  );
};
